import {
  SCHEDULER_GUIDE_MAGIC_DRAG_COPY_DIALOG,
  SCHEDULER_GUIDE_MAGIC_WELCOME_DIALOG,
  SCHEDULER_GUIDE_WELCOME_DIALOG,
} from '@/onboarding/dialogs';

export const STEP_ATTENDANCE_ADD_EMPLOYEES = 'addEmployee';
export const STEP_ATTENDANCE_EDIT_TIMESHEET = 'editTimesheet';
export const STEP_ATTENDANCE_EXPORT_TIMESHEET = 'exportTimesheet';

export const STEP_SCHEDULING_ADD_EMPLOYEES = 'addEmployee';
export const STEP_SCHEDULING_CREATE_SHIFT = 'createShift';
export const STEP_SCHEDULING_PUBLISH_SCHEDULE = 'publishSchedule';

export const STEP_PRELOADED_CREATE_SHIFT = 'createShift';
export const STEP_PRELOADED_REASSIGN_SHIFT = 'reassignShift';
export const STEP_PRELOADED_PUBLISH_SCHEDULE = 'publishSchedule';

export const ATTENDANCE_CHECKLIST_STEPS: AttendanceChecklistSteps = {
  [STEP_ATTENDANCE_ADD_EMPLOYEES]: {
    title: 'Add users',
    description: 'Use the add button to add your users.',
  },
  [STEP_ATTENDANCE_EDIT_TIMESHEET]: {
    title: 'Edit timesheet',
    description: 'Add clock in/out times to the timesheet.',
  },
  [STEP_ATTENDANCE_EXPORT_TIMESHEET]: {
    title: 'Export timesheets',
    description: 'Export an overview of hours worked.',
  },
};

export type AttendanceChecklistSteps = {
  [STEP_ATTENDANCE_ADD_EMPLOYEES]: {
    title: string;
    description: string;
  };
  [STEP_ATTENDANCE_EDIT_TIMESHEET]: {
    title: string;
    description: string;
  };
  [STEP_ATTENDANCE_EXPORT_TIMESHEET]: {
    title: string;
    description: string;
  };
};

export enum ListType {
  Attendance = 'attendance',
}

export enum SchedulerOnboardingItems {
  Publish = 'publish',
  PublishCelebrate = 'publishCelebrate',
  Welcome = 'welcome',
  CreateShift = 'createShift',
  AddUser = 'addUser',
  DragCopy = 'dragCopy',
  UnpublishedShift = 'unpublishedShift',
  PublishPreview = 'publishPreview',
  DemoShift = 'demoShift',
  ConnectPayroll = 'connectPayroll',
  MagicWelcome = 'magicWelcome',
  MagicDragCopy = 'magicDragCopy',
  ScheduleTemplate = 'scheduleTemplate',
}

export enum GuideTypes {
  Scheduler = 'scheduler',
}

export type OnboardingGuide = {
  completed: Array<SchedulerOnboardingItems>;
};

export const SchedulerGuidePath = [
  SchedulerOnboardingItems.Welcome,
  SchedulerOnboardingItems.AddUser,
  SchedulerOnboardingItems.CreateShift,
  SchedulerOnboardingItems.UnpublishedShift,
  SchedulerOnboardingItems.Publish,
  SchedulerOnboardingItems.PublishCelebrate,
  SchedulerOnboardingItems.DragCopy,
];

export const SchedulerGuidePathDemoShift = [
  SchedulerOnboardingItems.Welcome,
  SchedulerOnboardingItems.DemoShift,
  SchedulerOnboardingItems.AddUser,
  SchedulerOnboardingItems.UnpublishedShift,
  SchedulerOnboardingItems.Publish,
  SchedulerOnboardingItems.PublishCelebrate,
];

export const SchedulerGuidePathMagicImport = [
  SchedulerOnboardingItems.MagicWelcome,
  SchedulerOnboardingItems.MagicDragCopy,
  SchedulerOnboardingItems.ScheduleTemplate,
  SchedulerOnboardingItems.Publish,
  SchedulerOnboardingItems.PublishCelebrate,
];

export const GifGuidedDialogs = {
  [`${SchedulerOnboardingItems.Welcome as string}`]: SCHEDULER_GUIDE_WELCOME_DIALOG,
  [`${SchedulerOnboardingItems.MagicWelcome as string}`]: SCHEDULER_GUIDE_MAGIC_WELCOME_DIALOG,
  [`${SchedulerOnboardingItems.MagicDragCopy as string}`]: SCHEDULER_GUIDE_MAGIC_DRAG_COPY_DIALOG,
};

export enum EmployeeOnboardingItems {
  AvailabilityCompleted = 'availabilityCompleted',
  AlertPreferencesCompleted = 'alertPreferencesCompleted',
  TimeOffCompleted = 'timeOffCompleted',
}

export type EmployeeOnboardingSteps = {
  [key in EmployeeOnboardingItems]: boolean;
};

export enum EmployeeOnboardingStatus {
  Idle = 'idle',
  AlertPreferences = 'alertPreferences',
  Availability = 'availability',
  TimeOff = 'timeOff',
}
